// 格瓦拉App
// 点评APP
export default {
  appName: 'gewara',
  useKNB: true,
  sellChannel: 8,
  theme: 'gewara'
};